import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './skills.css';

function Skills() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const skillCategories = [
    {
      category: "Design",
      skills: ["Figma", "FigJam", "Miro", "Maze", "User Research", "Usability Testing", "Prototyping", "Journey Mapping"]
    },
    {
      category: "Development",
      skills: ["React.js", "JavaScript", "Python", "HTML/CSS", "C#", "Git", "Responsive Design"]
    },
    {
      category: "Business",
      skills: ["Account Management", "Customer Success", "Revenue Growth", "Team Leadership", "Project Management", "CRM"]
    },
    {
      category: "AI-Enabled Workflow",
      skills: ["Research Acceleration", "Customer Insight Synthesis", "Technical Problem-Solving", "Message Testing", "Market Analysis", "Moving from Ambiguity to Action"]
    }
  ];

  return (
    <div className="skills-section" ref={ref}>
      {/* Skills Section */}
      <motion.h2
        className="skills-heading"
        initial={{ opacity: 0, y: 30 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
        transition={{ duration: 0.6, delay: 0.6 }}
      >
        Skills & Tools
      </motion.h2>

      <div className="skills-categories">
        {skillCategories.map((category, catIndex) => (
          <div key={catIndex} className="skill-category">
            <motion.h3
              className="category-title"
              initial={{ opacity: 0, x: -20 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
              transition={{ duration: 0.5, delay: catIndex * 0.1 }}
            >
              {category.category}
            </motion.h3>
            <div className="skills-grid">
              {category.skills.map((skill, skillIndex) => (
                <motion.div
                  key={skillIndex}
                  className="skill-badge-item"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
                  transition={{
                    duration: 0.4,
                    delay: (catIndex * 0.2) + (skillIndex * 0.05)
                  }}
                  whileHover={{ scale: 1.05 }}
                >
                  {skill}
                </motion.div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;
